
import InfoIcon from '@mui/icons-material/Info';
import PaymentIcon from '@mui/icons-material/Payment';
import PersonIcon from '@mui/icons-material/Person';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import SummarizeIcon from '@mui/icons-material/Summarize';


export const REPMANAGER_APIKEY = "E5DC3D1-741E-48DC-8A27-59CA919232389y";
export const IS_ZERO = 0;
export const IS_ONE = 1;
export const ID_TYPE_EMIRATES_ID = 29;
export const MEMBER_DETAILS_PAGE_SIZE = 10;
export const IMPORT_MEMBER_PAGE_SIZE = 100;
export const IMPORT_MEMBER_FIRST_PAGE = 1;
export const PRODUCT_BASIC_NE = 41;
export const PRODUCT_ASASI_EMPLOYEE = 24;
export const MAF_ITEM_ID_41 = 41;
export const MAF_ITEM_ID_45 = 45;
export const MAF_ITEM_ID_59 = 59;
export const MAF_SHORT_QUESTIONAIRE_ID = 1;
export const MAF_FULL_QUESTIONAIRE_ID = 2;
export const MAF_IS_SUB_ITEM_FLAG_N = "N"
export const FEMALE_DOMAIN_ID = "Female";
export const MARRIED_DOMAIN_ID = "Married";
export const FEMALE_DOMAIN_ID_ID = 191;
export const MARRIED_DOMAIN_ID_ID = 20;
export const NE_REGION = 185;
export const ABU_DU_REGION = 186;
export const STEPS = [
    { label: 'Basic Info', image: 'img/info.png' },
    { label: 'Member Info', image: 'img/img1.png' },
    { label: 'Plan', image: 'img/summary-18.png' },
    { label: 'Full Member Details', image: 'img/4926094.png' },
    { label: 'KYC & Payment', image: 'img/2543190.png' },
];